import { createFileRoute, notFound } from '@tanstack/react-router'
import { differenceInMinutes, formatISO } from 'date-fns'
import { parseTimeRange } from 'grafbase-components/inputs/time/time-range-parse.ts'
import { object, optional, parse, string } from 'valibot'
import { Config } from '#app/config'
import node, {
  type graphUsagePageQuery,
} from '#gen/relay/graphUsagePageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

const UsagePageSearchParamsSchema = object({
  range: optional(string()),
  from: optional(string()),
  to: optional(string()),
})

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/usage',
)({
  staticData: { title: 'Usage' },
  validateSearch(search) {
    return parse(UsagePageSearchParamsSchema, search)
  },
  loaderDeps({ search }) {
    return {
      range: search.range ?? '7d',
      from: search.from,
      to: search.to,
    }
  },
  async loader({ context, deps, params }) {
    if (Config.IS_ENTERPRISE_BUILD) throw notFound()

    const { from, to } = parseTimeRange(deps.range, deps.from, deps.to)

    const diffInMinutes = differenceInMinutes(to, from)
    const diffInHours = diffInMinutes / 60

    let aggregationStep: string

    if (diffInHours > 24) aggregationStep = 'PT24H'
    else aggregationStep = 'PT1H'

    return context.preload<graphUsagePageQuery>(node, {
      filters: {
        from: formatISO(from),
        to: formatISO(to),
        graphSlug: params.graph,
        aggregationStep,
      },
      account: params.account,
    })
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/graph/usage/graph-usage-page'),
    'GraphUsagePage',
  ),
})
